import axios from "axios";
import CustomBlockButton from "../../../../../components/button/CustomBlockButton";
import { useApiInfoContextValueHook } from "../../../../../contexts/ApiInfoContextProvider";
import { SellertoolSignatureUtils } from "../../../../../utils/sellertool-signature-utils";
import * as St from './weget-event-buttons.styled';
import { customToast } from "../../../../../components/toast/custom-react-toastify/v1";
import { v4 as uuidv4 } from 'uuid';
import { useState } from "react";
import { SettingValueModal } from "./setting-value-modal";
import { Item, Bin, Packer } from '../../../../../utils/bin-packing-v6/3D';
import { BoxUtil } from "./utils/BoxUtil";
import { usePalletStandardRulesHook } from "../../../../../hooks/usePalletStandardRulesHook";

// const BinPacking3D = require('binpackingjs').BP3D;

// const { Item, Bin, Packer } = BinPacking3D;

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;
const PALLET_DEFAULT_HEIGHT = 150;

export function WegetEventButtons({
    pallets,
    loadItems,
    stageUUID,
    onReqBulkAdd,
    onReqBulkDelete
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const { rules: standardRules } = usePalletStandardRulesHook();

    const [settingValueModalOpen, setSettingValueModalOpen] = useState(false);
    const [palletWidth, setPalletWidth] = useState(1100);
    const [palletDepth, setPalletDepth] = useState(1100);
    const [palletHeight, setPalletHeight] = useState(1550);
    const [maxCBMOfExtraItems, setMaxCBMOfExtraItems] = useState(0.5);

    const handleCalculatePalletDatas = async () => {
        if (!stageUUID) {
            customToast.error('스테이지를 선택해주세요.');
            return;
        }

        const purchasingItems = await handleReqGetWarehousingItems();

        if (!purchasingItems) {
            customToast.error('불러올 데이터가 없습니다.');
            return;
        }

        const palletDatas = await BoxUtil().boxUp(purchasingItems, palletWidth, palletHeight - PALLET_DEFAULT_HEIGHT, palletDepth, maxCBMOfExtraItems, standardRules);
        const pallets = palletDatas?.map(r => {
            return {
                _id: null,
                uuid: r.palletUUID,
                palletNumber: r.palletNumber,
                type: r.type,
                rackLocationAddress: '',
                childRackLocationAddresses: [],
                stageUUID: stageUUID,
            }
        })
        const loadItems = palletDatas?.reduce((prev, curr) => {
            const lItems = curr.devidedSubItems?.map(subItems => {
                return {
                    _id: null,
                    uuid: subItems?.devidedSubItemUUID,
                    waybillNumber: subItems?.waybillNumber,
                    productName: subItems?.warehousingProductName,
                    optionName: subItems?.warehousingOptionName,
                    optionCode: subItems?.optionCode,
                    boxWidth: subItems?.boxWidth,
                    boxDepth: subItems?.boxDepth,
                    boxHeight: subItems?.boxHeight,
                    boxCBM: subItems?.boxCBM,
                    boxQuantity: subItems?.boxQuantity,
                    estimatedProductQuantity: subItems?.estimatedProductQuantity,
                    originProductQuantity: subItems?.productQuantity,
                    warehousingItemId: subItems?.warehousingItemId,
                    warehousingItemUUID: subItems?.warehousingItemUUID,
                    expectedPalletNumber: curr.palletNumber,
                    expectedPalletUUID: curr?.palletUUID,
                    palletNumber: curr.palletNumber,
                    palletUUID: curr?.palletUUID,
                    loadedYn: 'n',
                    workspaceId: subItems?.workspaceId,
                    stageUUID: stageUUID,
                }
            });
            return prev.concat(lItems);
        }, []);
        // onSetPallets(pallets);
        // onSetLoadItems(loadItems);
        onReqBulkAdd(pallets, loadItems);
    }

    const handleReqGetWarehousingItems = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const params = {
            status: 'IN_PROGRESS',
            stageUUID: stageUUID,
        }

        const warehousingItemsResult = await axios.get(`${API_HOST}/warehousing-items`, {
            headers: headers,
            params: params
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (warehousingItemsResult?.content) {
            if (warehousingItemsResult?.content?.length <= 0) {
                return null;
            }
            return warehousingItemsResult?.content?.map(r => {
                return {
                    ...r,
                    warehousingItemId: r.id,
                    warehousingItemUUID: r.uuid
                }
            });
        }
    }

    const handleSaveSettingValues = (settingValues) => {
        setPalletWidth(settingValues.palletWidth);
        setPalletDepth(settingValues.palletDepth);
        setPalletHeight(settingValues.palletHeight);
        setMaxCBMOfExtraItems(settingValues.maxCBMOfExtraItems);
    }

    let infoDatas = getInfoDatas(pallets, loadItems);

    return (
        <>
            <St.Container>
                <St.Buttons>
                    <div className='flex gap-2 justify-end'>
                        <CustomBlockButton
                            type='button'
                            onClick={() => setSettingValueModalOpen(true)}
                        >
                            세팅값
                        </CustomBlockButton>
                        {!pallets &&
                            <CustomBlockButton
                                type='button'
                                onClick={() => handleCalculatePalletDatas()}
                                className='load'
                            >
                                불러오기
                            </CustomBlockButton>
                        }
                        {(pallets && pallets[0]?._id) &&
                            <CustomBlockButton
                                type='button'
                                onClick={() => onReqBulkDelete()}
                                className='initialize'
                            >
                                초기화
                            </CustomBlockButton>
                        }
                        {(pallets && !pallets[0]?._id) &&
                            <CustomBlockButton
                                type='button'
                                onClick={() => onReqBulkAdd()}
                                className='save'
                            >
                                저장하기
                            </CustomBlockButton>
                        }
                    </div>
                </St.Buttons>
                {(pallets && pallets?.length > 0 && loadItems && loadItems?.length > 0) &&
                    <St.Body.Container>
                        <St.Body.Wrapper>
                            <St.Body.Card>
                                <div className='label'>
                                    총 카톤수
                                </div>
                                <div className='data'>
                                    {infoDatas.totalCTNS ? `${infoDatas.totalCTNS} CNTS` : '불러오는 중'}
                                </div>
                            </St.Body.Card>
                            <St.Body.Card>
                                <div className='label'>
                                    총 CBM
                                </div>
                                <div className='data'>
                                    {infoDatas.totalCBM ? `${infoDatas.totalCBM} CBM` : '불러오는 중'}
                                </div>
                            </St.Body.Card>
                            <St.Body.Card>
                                <div className='label'>파레트 수량</div>
                                <div className='data'>
                                    {infoDatas.palletCount ? `${infoDatas.palletCount} 개` : '불러오는 중'}
                                </div>
                            </St.Body.Card>
                        </St.Body.Wrapper>
                    </St.Body.Container>
                }
            </St.Container>

            {settingValueModalOpen &&
                <SettingValueModal
                    open={settingValueModalOpen}
                    onClose={() => setSettingValueModalOpen(false)}
                    currentPalletWidth={palletWidth}
                    currentPalletDepth={palletDepth}
                    currentPalletHeight={palletHeight}
                    currentMaxCBMOfExtraItems={maxCBMOfExtraItems}
                    onSave={handleSaveSettingValues}
                />
            }
        </>
    );
}

async function calculatePallet(purchasingItems, palletWidth, palletDepth, palletHeight, maxCBMOfExtraItems) {
    const normalItems = [];
    const heteromorphicItems = [];
    let extraItems = [];

    purchasingItems.forEach(r => {
        const boxSize = [r.boxWidth, r.boxDepth, r.boxHeight]; // mm 단위로 변환

        boxSize.sort((a, b) => b - a); // 가장 긴 부분을 width, 두번째로 긴 부분은 depth, 가장 짧은 부분을 height로 정렬

        if ((boxSize[0] > palletWidth && boxSize[0] > palletDepth) || (boxSize[1] > palletWidth && boxSize[1] > palletDepth)) {
            heteromorphicItems.push({
                ...r,
                boxWidth: boxSize[0],
                boxDepth: boxSize[1],
                boxHeight: boxSize[2],
            })
        } else {
            normalItems.push({
                ...r,
                boxWidth: boxSize[0],
                boxDepth: boxSize[1],
                boxHeight: boxSize[2],
            })
        }
    });

    let pallets = [];

    normalItems.sort((a, b) => {
        if (`${a.warehousingProductName}_${a.warehousingOptionName}` < `${b.warehousingProductName}_${b.warehousingOptionName}`) return -1;
        if (`${a.warehousingProductName}_${a.warehousingOptionName}` > `${b.warehousingProductName}_${b.warehousingOptionName}`) return 1;
        return 0;
    });

    const normalItemsAggregations = [];
    let queue = [];

    normalItems.forEach(normalItem => {
        if (queue.length <= 0) {
            queue.push(normalItem);
            return;
        }

        if (`${queue[0].warehousingProductName}` === `${normalItem.warehousingProductName}`) {
            queue.push(normalItem);
        } else {
            normalItemsAggregations.push({
                warehousingProductName: queue[0].warehousingProductName,
                subItems: [...queue]
            })

            queue = [{ ...normalItem }];
        }
    })

    if (queue?.length > 0) {
        normalItemsAggregations.push({
            warehousingProductName: queue[0].warehousingProductName,
            subItems: [...queue]
        })
    }

    normalItemsAggregations.forEach(normalItemsAggregation => {
        let totalCBM = 0;
        const devidedSubItems = normalItemsAggregation.subItems.reduce((prev, curr) => {
            totalCBM += (curr.boxCBM * curr.boxQuantity);

            if (!curr.boxQuantity || curr.boxQuantity <= 0) {
                return prev.concat({ ...curr, boxQuantity: 0, estimatedProductQuantity: curr?.productQuantity })
            }

            const items = [];
            const estimatedProductQuantity = Math.round((curr?.productQuantity / curr.boxQuantity) * 100) / 100;

            for (let i = 0; i < curr.boxQuantity; i++) {
                items.push({
                    ...curr,
                    boxQuantity: 1,
                    estimatedProductQuantity: estimatedProductQuantity,
                })
            }

            return prev.concat([...items])
        }, []);

        if (totalCBM < maxCBMOfExtraItems) {
            extraItems = extraItems.concat([...devidedSubItems]);
        } else {
            const packaingResult = myPackingFunction(devidedSubItems, pallets, 'NORMAL', palletWidth, palletDepth, palletHeight, maxCBMOfExtraItems);
            if (packaingResult?.length > 0) {
                pallets = pallets.concat(packaingResult);
            }
        }
    })

    const extraItemsPackingResult = myPackingFunction(extraItems, pallets, 'EXTRA', palletWidth, palletDepth, palletHeight, maxCBMOfExtraItems);
    if (extraItemsPackingResult?.length > 0) {
        pallets = pallets.concat(extraItemsPackingResult);
    }

    const newHeteromorphicItems = heteromorphicItems?.reduce((prev, curr) => {
        const items = [];

        if (!curr.boxQuantity || curr.boxQuantity <= 0) {
            return prev.concat({ ...curr, boxQuantity: 0, estimatedProductQuantity: curr?.productQuantity })
        }

        const estimatedProductQuantity = Math.round((curr?.productQuantity / curr.boxQuantity) * 100) / 100;

        for (let i = 0; i < curr.boxQuantity; i++) {
            items.push({
                ...curr,
                boxQuantity: 1,
                estimatedProductQuantity: estimatedProductQuantity,
            })
        }

        return prev.concat([...items]);
    }, []);
    const heteromorphicItemsPackingResult = myPackingFunction(newHeteromorphicItems, pallets, 'HETEROMORPHIC', palletWidth + 1000, palletDepth + 1000, palletHeight, maxCBMOfExtraItems);
    if (heteromorphicItemsPackingResult?.length > 0) {
        pallets = pallets.concat(heteromorphicItemsPackingResult);
    }

    return pallets;
}

function myPackingFunction(items, originPallet, type = 'NORMAL', palletWidth, palletDepth, palletHeight, maxCBMOfExtraItems) {
    let targetItems = items.map(r => {
        return {
            devidedSubItemUUID: uuidv4(),
            ...r,
        }
    })
    let pallets = [];
    let palletIdx = 1;
    let trierCount = 0;


    while (targetItems?.length > 0) {
        let packer = new Packer();
        // let pallet = new Bin("PALLET", palletWidth, palletHeight, palletDepth);
        let pallet = new Bin("PALLET", palletWidth, palletHeight, palletDepth, 10000, 100);

        packer.addBin(pallet);

        targetItems.forEach(r => {
            const itemWidth = r.boxQuantity <= 0 ? 0 : r.boxWidth;
            const itemDepth = r.boxQuantity <= 0 ? 0 : r.boxDepth;
            const itemHeight = r.boxQuantity <= 0 ? 0 : r.boxHeight;
            const mustBeFlat = shouldItemBeFlat(itemWidth, itemHeight, itemDepth);
            packer.addItem(new Item(`${r.devidedSubItemUUID}`, itemWidth, itemHeight, itemDepth, null, null, mustBeFlat));
        })

        // pack items into bin1
        packer.pack();
        let palletedIds = pallet.items?.map(r => r.name);
        let unfitedItemIds = packer.unfitItems?.map(r => r.name);

        const palletedItems = targetItems.filter(r => palletedIds.includes(r.devidedSubItemUUID)).map(r => {
            let newItem = { ...r };
            return newItem
        });

        if (palletedItems?.length > 0) {
            pallets = pallets.concat({
                type: type,
                palletUUID: uuidv4(),
                palletNumber: originPallet.length + palletIdx,
                devidedSubItems: palletedItems,
            })
        }

        if (unfitedItemIds?.length <= 0) {
            break;
        }

        targetItems = targetItems.filter(r => unfitedItemIds.includes(r.devidedSubItemUUID));
        palletIdx++;
        trierCount++;

        if (trierCount > 500) {
            console.log('trierCount', trierCount)
            break;
        }

        // // item1, item2, item3
        // console.log(palletedIds);

        // // items will be empty, all items was packed
        // console.log(packer.items);

        // // unfitItems will be empty, all items fit into bin1
        // console.log(packer.unfitItems)
    }

    return pallets;
}

function getInfoDatas(pallets, loadItems) {
    const palletCount = pallets?.length;
    let totalCTNS = 0;
    let totalCBM = 0;

    loadItems?.forEach(r => {
        if (r.boxQuantity > 0) {
            totalCTNS += r.boxQuantity;
            totalCBM += r.boxQuantity * r.boxCBM;
        }
    })

    totalCBM = Math.round(totalCBM * 100) / 100;
    return {
        palletCount: palletCount,
        totalCTNS: totalCTNS,
        totalCBM: totalCBM,
    }
}

function shouldItemBeFlat(W, H, D, stableHeightThreshold = 200) {
    // 1. 절대 기준 활용
    if (H < stableHeightThreshold) {
        return true;
    }

    // 2. 상대 기준 활용
    // 예: 높이가 다른 치수에 비해 극단적으로 낮으면 평평하게 놓아야 한다고 판단
    const smallestHorizontalDim = Math.min(W, D);
    if (H < 0.5 * smallestHorizontalDim) {
        return true;
    }

    // 위의 기준에 해당하지 않으면 세울 수도 있다는 가정 하에 false 반환
    return false;
}